// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3pmYS","notes":"Notes_notes__v5N6-"};